import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SiteDetailsModel } from 'src/app/models/SiteDetails/SiteDetailsModel';
import { add, differenceInCalendarDays, parseISO } from 'date-fns';
import { SiteWeatherForecastModel } from 'src/app/models/SiteDetails/SiteWeatherForecastModel';
import { formatDate } from '@angular/common';
import { String } from 'lodash';
import { convertToAESTDateTime, getTimezoneOffset } from 'src/app/shared/utils';

@Component({
	selector: 'app-forecast-widget',
	templateUrl: './forecast-widget.component.html',
	styleUrls: ['./forecast-widget.component.scss']
})
export class ForecastWidgetComponent implements OnInit, OnChanges {
	@Input() siteDetails : SiteDetailsModel;

	weatherTypes : string[] = ["Weather", "Rainfall", "Wind", "Swell", "Tide"];
	weatherForecastData : SiteWeatherForecastModel[] = [];
	days : Date[] = [];

	timeZoneOffset = getTimezoneOffset();

	ngOnInit() {
		const today = new Date();
		for(let i = 0; i < 3; ++i)
		{
			const interval = add(today, { days : i });
			this.days.push(interval);
		}
	}

	ngOnChanges(changes : SimpleChanges) {
		if(!changes["siteDetails"])
		{
			this.weatherForecastData = [];
			return;			
		}
		
		const details = <SiteDetailsModel>(<unknown>changes["siteDetails"].currentValue);
		if(!details?.Identifier)
		{
			this.weatherForecastData = [];
			return;
		}
		const today = new Date();
		const interval = add(today, { days : 2 });
		const maxDate = new Date(interval.getFullYear(), interval.getMonth(), interval.getDate());
		this.weatherForecastData = details?.WeatherForecast?.filter((a : SiteWeatherForecastModel) => {
			let matches = false;
			try
			{
				const forecastDateTime = new Date(Date.parse(a.ForecastDateTime?.toString()));
				const dayDate = new Date(forecastDateTime.getFullYear(), forecastDateTime.getMonth(), forecastDateTime.getDate());
				const difference = differenceInCalendarDays(maxDate, dayDate);
				matches = difference >= 0 && difference <= 2;
			}	
			catch(ex)
			{

			}
			return matches;
		}).sort((a, b) => {
			let result = 0;
			try
			{
				const forecastDateTimeA = new Date(Date.parse(a.ForecastDateTime?.toString()));
				const forecastDateTimeB = new Date(Date.parse(b.ForecastDateTime?.toString()));
				result = forecastDateTimeA?.getTime() - forecastDateTimeB?.getTime();
			}
			catch(ex)
			{

			}
			return result;
			
		});		
	}

	canDisplayRow = (weatherType : string) => {
		let yesNo : boolean = true;
		if((weatherType === this.weatherTypes[3] && !this.siteDetails?.ShowSwell) ||
			(weatherType === this.weatherTypes[4] && !this.siteDetails?.ShowTide))
		{
			yesNo = false;
		}


		return yesNo;
	}

	getLocalDateTime = (inDate : any) => {
		return convertToAESTDateTime(inDate);
	}
	
}
